import { managerAdminPath } from "./constants";
import { SCREEN_IDS } from "../../system/global-enums";

import ManagerProfile from "./views/managerProfile/managerProfile";
import ManagerPerformance from "./views/managerPerformance/managerPerformance";

import Inbox from "../shared-screens/views/inbox/inbox";
import Dashboard from "../shared-screens/views/dashboard/dashboard";
import UserProfile from "../shared-screens/views/userProfile/userProfile";
import UserPermissions from "../shared-screens/views/userPermissions/userPermissions";
import ConsumerResponses from "../shared-screens/views/consumerResponses/consumerResponses";
import IndividualStoreProfile from "../shared-screens/views/individualStoreProfile/individualStoreProfile";
import IndividualStorePerformance from "../shared-screens/views/individualStorePerformance/individualStorePerformance";

const ManagerRoutes = [
  {
    path: managerAdminPath.MANAGER_PROFILE,
    name: "brand-restaurants",
    screenId: SCREEN_IDS.BRANDS,
    component: ManagerProfile,
    displayName: "Manager Stores",
    breadcrumb: "Manager Profile",
  },
  {
    path: managerAdminPath.MANAGER_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS,
    component: ManagerPerformance,
    displayName: "Manager Performance",
    breadcrumb: "Manager Performance",
  },
  // Consumer Responses
  {
    path: managerAdminPath.CONSUMER_RESPONSES_BY_PERFORMANCE,
    name: "consumer-response",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  {
    path: managerAdminPath.CONSUMER_RESPONSES_BY_MANAGER_PROFILE,
    name: "consumer-response",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: ConsumerResponses,
    displayName: "Consumer Responses",
    breadcrumb: "Consumer Responses",
  },
  // Individual Performance
  {
    path: managerAdminPath.RESTAURANT_PERFORMANCE_BY_PERFORMANCE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  {
    path: managerAdminPath.RESTAURANT_PERFORMANCE_BY_MANAGER_PROFILE,
    name: "performance",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStorePerformance,
    displayName: "Guest Feedback",
    breadcrumb: "Performance",
  },
  // Individual Store Profile
  {
    path: managerAdminPath.RESTAURANT_PROFILE_BY_PERFORMANCE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: managerAdminPath.RESTAURANT_PROFILE_BY_MANAGER_PROFILE,
    name: "survey-profile",
    screenId: SCREEN_IDS.BRANDS_LOCATIONS,
    component: IndividualStoreProfile,
    displayName: "Survey Profile",
    breadcrumb: "Store Profile",
  },
  {
    path: managerAdminPath.USER_PROFILE,
    name: "userProfile",
    screenId: SCREEN_IDS.BRANDS,
    component: UserProfile,
    displayName: "User Profile",
    breadcrumb: "User Profile",
  },
  {
    path: managerAdminPath.MANAGER_USER_PERMISSIONS,
    name: "user-permissions",
    screenId: SCREEN_IDS.BRANDS,
    component: UserPermissions,
    displayName: "User Permissions",
    breadcrumb: "Permissions",
  },
  {
    path: managerAdminPath.MANAGER_INBOX,
    name: "manager-inbox",
    screenId: SCREEN_IDS.BRANDS,
    component: Inbox,
    displayName: "Messages",
    breadcrumb: "Manager Inbox",
  },
  {
    path: managerAdminPath.DASHBOARD_BY_MANAGER_ADMIN,
    name: "dashboard",
    screenId: SCREEN_IDS.BRANDS,
    component: Dashboard,
    displayName: "Dashboard",
    breadcrumb: "Dashboard",
  },
];

export default ManagerRoutes;
